import React from "react";

import { Form, Formik } from "formik";
import {
  Resiliation,
  informationsSchema,
} from "modules/resiliation/model/resiliation";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { TextInput } from "shared/components/text-input/text-input";
import { FormulaireSubmit } from "./formulaire-submit";
import './formulaire.scss';

export interface IFormulaireStep1Props {
  resiliation: Resiliation;
  submit: (resiliation: Resiliation) => void;
  cancel: () => void;
}

export const FormulaireStep1 = ({
  resiliation,
  submit,
  cancel,
}: IFormulaireStep1Props) => {
  const navigate = useNavigate()

  return (
    <div>
      <div className={isMobile ? 'content-mobile' : 'content'} >
        <div className="container-box">
          <Formik
            initialValues={resiliation.informations}
            validationSchema={informationsSchema}
            onSubmit={(values) => {
              submit({ ...resiliation, ...{ informations: { ...values } } });
            }}
          >
            {({ values, errors, touched, handleChange, setFieldValue }) => {
              return (
                <Form>
                  <div className="row top-buffer pt-4" style={isMobile ? { flexDirection: "column" } : {}} >
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}} >
                      <TextInput
                        label="Nom* "
                        autoComplete="off"
                        type="text"
                        name="lastname"
                        placeholder="ex : Dupont"
                        initialValue={values.lastname}
                        touched={touched.lastname}
                        handleChange={handleChange}
                        error={errors.lastname}
                      />
                    </div>
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="Prénom* "
                        autoComplete="off"
                        type="text"
                        name="firstname"
                        placeholder="ex : Corinne"
                        initialValue={values.firstname}
                        touched={touched.firstname}
                        handleChange={handleChange}
                        error={errors.firstname}
                      />
                    </div>
                  </div>
                  <div className="row top-buffer pt-4" style={isMobile ? { flexDirection: "column" } : {}} >
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="Date de naissance* "
                        autoComplete="off"
                        type="date"
                        name="dateNaissance"
                        placeholder=""
                        initialValue={values.dateNaissance}
                        touched={touched.dateNaissance}
                        handleChange={handleChange}
                        error={errors.dateNaissance}
                        max={new Date().toISOString().split('T')[0]}
                      />
                    </div>
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}} >
                      <TextInput
                        label="Téléphone* "
                        autoComplete="off"
                        type={"tel"}
                        name="numTel"
                        placeholder="ex: 0600000000"
                        initialValue={values.numTel}
                        touched={touched.numTel}
                        handleChange={handleChange}
                        error={errors.numTel}
                      />
                    </div>
                  </div>
                  <div className="row top-buffer pt-4" style={isMobile ? { flexDirection: "column" } : {}} >
                    <div className="col-4" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="N° de rue "
                        autoComplete="off"
                        type="text"
                        name="nRue"
                        placeholder="ex : 71"
                        initialValue={values.nRue}
                        touched={touched.nRue}
                        handleChange={handleChange}
                        error={errors.nRue}
                      />
                    </div>
                    <div className="col-8" style={isMobile ? { width: "100%" } : {}} >
                      <TextInput
                        label="Adresse* "
                        autoComplete="off"
                        type="text"
                        name="adresse"
                        placeholder="ex : quai Colbert"
                        initialValue={values.adresse}
                        touched={touched.adresse}
                        handleChange={handleChange}
                        error={errors.adresse}
                      />
                    </div>
                  </div>
                  <div className="row top-buffer py-4" style={isMobile ? { flexDirection: "column" } : {}} >
                    <div className="col-4" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="Code Postal* "
                        autoComplete="off"
                        type="text"
                        name="codePostal"
                        placeholder="ex : 76095"
                        initialValue={values.codePostal}
                        touched={touched.codePostal}
                        handleChange={handleChange}
                        error={errors.codePostal}
                      />
                    </div>
                    <div className="col-8" style={isMobile ? { width: "100%" } : {}} >
                      <TextInput
                        label="Ville* "
                        autoComplete="off"
                        type="text"
                        name="ville"
                        placeholder="ex : Le Havre"
                        initialValue={values.ville}
                        touched={touched.ville}
                        handleChange={handleChange}
                        error={errors.ville}
                      />
                    </div>
                  </div>
                  <div className="row top-buffer " style={isMobile ? { flexDirection: "column" } : {}} >
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}} >
                      <TextInput
                        label="E-mail* "
                        autoComplete="off"
                        type="text"
                        name="email"
                        placeholder="ex : nom.prenom@email.fr"
                        initialValue={values.email}
                        touched={touched.email}
                        handleChange={handleChange}
                        error={errors.email}
                      />
                    </div>
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="Confirmation E-mail* "
                        autoComplete="off"
                        type="text"
                        name="emailComfirmation"
                        placeholder="ex : nom.prenom@email.fr"
                        initialValue={values.emailComfirmation}
                        touched={touched.emailComfirmation}
                        handleChange={handleChange}
                        error={errors.emailComfirmation}
                      />
                    </div>
                    <div className="textFooter pt-4">
                      <div className="textFooter1">* Champs obligatoires</div>
                    </div>
                  </div>
                  <FormulaireSubmit />
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  )
}